import { Standard } from '@getvim/vim-connect';
import { orderA, orderB, orderC, orderG, editableOrder } from '../orders';
import { minnieMouse, natashaDavies, stevenVazquez } from '../patients';

export const predefinedPayloads: Record<string, Standard.Events.OrdersViewedPayload> = {
  'Minnie Mouse - Orders A-B': {
    patient: minnieMouse,
    selectedOrders: [orderA, orderB],
    editableOrder,
  },
  'Minnie Mouse - Orders A-G': {
    patient: minnieMouse,
    selectedOrders: [orderA, orderG],
    editableOrder,
  },
  'Steven Vazquez - Order B-C': {
    patient: stevenVazquez,
    selectedOrders: [orderB, orderC],
    editableOrder,
  },
  'Natasha Davies - Order A-C': {
    patient: natashaDavies,
    selectedOrders: [orderA, orderC],
    editableOrder,
  },
};
